import classnames from 'classnames/bind'
import Image from '@/components/common/Image'
import { isEmpty } from 'lodash-es'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from '@/redux/hooks'

// Methods
import handleCopyValue from '@/methods/handleCopyValue'

// Components
import Link from '@/components/common/Link'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

function SimpleHeader() {
  const { t } = useTranslation()
  const memberData = useAppSelector((state) => state?.member?.memberData)

  const handleEmailClick = () => {
    handleCopyValue({ t, value: EXTERNAL_LINK.SQUARE_RECORDS_CONTACT_EMAIL })
  }

  return (
    <header className={cx('header')}>
      <div className={cx('header__wrapper')}>
        <div className={cx('header__start')}>
          <Link url={EXTERNAL_LINK.SQUARE_RECORDS_OFFICIAL_SITE} isOpen>
            <div className={cx('header-logo')}>
              <Image src='/images/square-records-logo.png' width={80} height={80} alt='Square Records' />
            </div>
          </Link>
          {!isEmpty(memberData.refCode) && <div className={cx('header__code')}>ID: {memberData.refCode}</div>}
        </div>

        <div className={cx('header__actions')}>
          <button type='button' className={cx('header__action')} onClick={handleEmailClick} aria-label='Email'>
            <Image src='/images/square-records-email-icon.png' width={28} height={28} alt='' />
          </button>
          <a
            className={cx('header__action')}
            href={EXTERNAL_LINK.SQUARE_RECORDS_OFFICIAL_SITE}
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Instagram'
          >
            <Image src='/images/square-records-ig-icon.png' width={28} height={28} alt='' />
          </a>
        </div>
      </div>
    </header>
  )
}

export default SimpleHeader
